module.exports = __webpack_public_path__ + "static/media/mergeRight.f3e13cc4.svg";